import React, { useState } from 'react';
import './About.css';

const About = () => {
  const [showMore, setShowMore] = useState(false);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="about-section" id="about-us">
      <h1>ABOUT SHIVRAJ CAR RENTALS</h1>
      <h2>-:-</h2>

      <p className="about-paragraph">
        <strong>Shivraj Tours & Travels in Solapur</strong> is a trusted
        <strong> Travel Agency in Solapur</strong> providing reliable and
        comfortable <strong>Travel Services in Solapur</strong> for local,
        outstation, business, family and pilgrimage journeys. We provide
        professional <strong>Cab Service in Solapur</strong>,
        <strong> Taxi Service in Solapur</strong>,
        <strong> Car Rental in Solapur</strong> and customized tour packages
        for our valued customers.

        <br /><br />

        Whether you need a <strong>Solapur Taxi Service</strong> for local
        travel, <strong>Solapur Cab Service</strong> for outstation journeys,
        <strong>Taxi Booking in Solapur</strong>,
        <strong>Cab Booking in Solapur</strong> or a
        <strong>Car Rental Service in Solapur</strong>, our experienced team
        is ready to assist you. We also provide
        <strong>Airport Taxi Solapur</strong>,
        <strong>Outstation Taxi Solapur</strong>,
        <strong>Outstation Cab Solapur</strong>,
        <strong>One Way Taxi Solapur</strong> and
        <strong>Round Trip Taxi Solapur</strong> services.

        <br /><br />

        Our dedicated team ensures high-quality service, comfort and
        reliability. All our chauffeurs are experienced, trained and
        professionally attired, with mobile phones for easy accessibility.
        Our goal is to make every journey safe, comfortable and convenient
        for our customers.
      </p>

      {showMore && (
        <p className="about-paragraph">
          We provide <strong>Tour Operator in Solapur</strong> services and
          customized travel solutions for individuals, families, corporate
          travellers and groups. Our services include
          <strong> Tourist Car Rental Solapur</strong>,
          <strong> Car With Driver Solapur</strong>,
          <strong> Tourist Car Hire Solapur</strong> and
          <strong>Tempo Traveller Rental Solapur</strong>.

          <br /><br />

          We offer cars and coaches for airport transfers, full-day local
          usage and outstation trips. Customers can choose rental packages
          based on kilometres, full-day or half-day usage. The total travel
          fare includes vehicle rental charges and driver's allowance.
          Additional charges may apply if the journey exceeds the selected
          package limits.

          <br /><br />

          We provide a range of vehicles according to your travel
          requirements, including <strong>Innova Crysta on Rent Solapur</strong>,
          <strong> Ertiga on Rent Solapur</strong>,
          <strong> Swift Dzire on Rent Solapur</strong>,
          <strong> Cruiser on Rent Solapur</strong>,
          <strong> SUV Rental Solapur</strong> and
          <strong>Luxury Car Rental Solapur</strong>. Our
          <strong> Car With Driver Solapur</strong> service is suitable for
          local sightseeing, airport transfers, family trips and long-distance
          travel.

          <br /><br />

          <strong>Tour & Pilgrimage Services</strong>

          <br /><br />

          Shivraj Tours & Travels also specializes in pilgrimage and
          sightseeing journeys. We provide
          <strong> Akkalkot Taxi Service</strong>,
          <strong> Pandharpur Taxi Service</strong>,
          <strong> Tuljapur Taxi Service</strong> and
          <strong> Ganagapur Taxi Service</strong>.

          <br /><br />

          Our popular pilgrimage packages include
          <strong> Akkalkot Pandharpur Tuljapur Tour</strong>,
          <strong> Solapur Pilgrimage Tour</strong>,
          <strong> Solapur Darshan Tour</strong> and
          <strong> Temple Tour Package Solapur</strong>. We also arrange
          customized <strong>Maharashtra Tour Packages</strong> and
          <strong>Karnataka Tour Packages</strong> according to your
          destination, duration and travel requirements.

          <br /><br />

          From <strong>Solapur Taxi Service</strong> and
          <strong>Taxi Service in Solapur</strong> to
          <strong>Cab Service in Solapur</strong>,
          <strong>Car Rental in Solapur</strong> and
          <strong>Tours and Travels in Solapur</strong>, we aim to provide
          dependable transportation with comfortable vehicles and
          experienced drivers.

          <br /><br />

          <strong>Why Shivraj Tours & Travels?</strong>

          <br /><br />

          1. Instant Booking Confirmation.<br />
          2. Experienced and Reliable Drivers.<br />
          3. Transparent Billing.<br />
          4. Neat and Clean AC Cabs.<br />
          5. Call Support During the Trip.<br />
          6. Flexible Tariff Plans.<br />
          7. Doorstep Service.<br />
          8. Customer-Friendly Cancellation Policy.<br />
          9. No Hidden Charges or Taxes.<br />
          10. Professional service based on ethics and values.

          <br /><br />

          For local travel, pilgrimage, sightseeing, airport transfers or
          outstation journeys, choose Shivraj Tours & Travels for reliable
          <strong>Cab Booking Solapur</strong>,
          <strong>Taxi Booking Solapur</strong> and
          <strong>Car Rental Service in Solapur</strong>.

          <br /><br />

          We serve popular routes and destinations including
          <strong>Solapur to Akkalkot</strong>,
          <strong>Solapur to Tuljapur</strong>,
          <strong>Solapur to Pandharpur</strong>,
          <strong>Solapur to Pune</strong>,
          <strong>Solapur to Latur</strong>,
          <strong>Solapur to Vijayapura</strong>,
          <strong>Solapur to Mumbai</strong>,
          <strong>Solapur to Hyderabad</strong> and
          <strong>Solapur to Bengaluru</strong>.

          <br /><br />

          Whether you require a <strong>One Way Taxi Solapur</strong>,
          <strong>Round Trip Taxi Solapur</strong>,
          <strong>Solapur Airport Taxi</strong>,
          <strong>Solapur Outstation Taxi</strong>,
          <strong>Solapur Outstation Cab</strong> or a
          <strong>Tourist Car Rental Solapur</strong>, Shivraj Tours &
          Travels provides convenient travel solutions for your journey.
        </p>
      )}

      <button className="toggle-button" onClick={handleToggle}>
        {showMore ? 'Show Less' : 'Read More'}
      </button>
    </div>
  );
};

export default About;